<div class="dropdown-menu align-dropdown-small-device dropdown-menu-end  dropdown-menu--credits" id="credits-dropdown">
  <div>
    <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device spacing mt-0 mb-4" [(activeId)]="activeId">
      <ng-template #subscriptionsTab>
        <div>
          <ul *ngIf="bundle" class="credits-list credits-list-subscriptions list-unstyled mb-3">
            <h3>{{ bundle.details[0].subscriptionLabel | translate }}</h3>
            <div class="d-flex flex-column">
              <span style="font-size: 13px;" class="mb-1"
                >{{ 'topmenu_subscription_renewal_date' | translate }}: {{ formateDate(bundle.details[0].subscriptionExpiryTime) }}</span
              >
              <span style="font-size: 13px; width: 90%;" translate>topmenu_packs_and_subscriptions_help</span>
              <span class="dropdown-menu__label d-flex justify-content-end mb-2" translate>topmenu_creditsdetail</span>
            </div>

            <li class="credits-list__item  credit" *ngFor="let subscription of subBundled">
              <div class="w-100">
                <div *ngIf="subscription.details.bundled && subscription.type === 'sms'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_credits_included</span>
                  <span class="credit__checkbox"
                    >{{ subscription.details.currentCreditSms }}/{{ subscription.details.initialCreditSms }}</span
                  >
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'email'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_subscription_email</span>
                  <span class="credit__checkbox">{{ subscription.details.bandwidth }}/h</span>
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'pages'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_subscription_pages</span>
                  <span class="credit__checkbox"
                    >{{ subscription.details.maxDomains }} {{ 'topmenu_domains' | translate }}, {{ subscription.details.maxPages }}
                    {{ 'topmenu_pages' | translate }}</span
                  >
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'richsms'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_subscription_rich</span>
                  <img class="icon-present" src="assets/images/icons/icon-success.svg" />
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'sr'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>generic_subscription_sr</span>
                  <span> {{ subscription.details.idSim }}</span>
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'rpc'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_rpc</span>
                  <img class="icon-present" src="assets/images/icons/icon-success.svg" />
                </div>
                <div *ngIf="subscription.details.bundled && subscription.type === 'srmo'" class="d-flex justify-content-between mb-1">
                  <span class="dropdown-menu__label" translate>topmenu_srmo</span>
                  <img class="icon-present" src="assets/images/icons/icon-success.svg" />
                </div>
              </div>
            </li>
          </ul>

          <ul *ngIf="singleSub && singleSub.length !== 0" class="credits-list credits-list-subscriptions list-unstyled  mb-4">
            <h3 translate>topmenu_single_subscriptions</h3>
            <span class="dropdown-menu__label  d-block" translate>topmenu_subscription_expiry_date</span>

            <li class="credits-list__item  credit" *ngFor="let subscription of singleSub">
              <div style="width: 100%; min-height: 26px">
                <div class="custom-display-subscription">
                  <span class="credit__name">{{
                    subscription.details.subscriptionName ||
                      (subscription.details.subscriptionLabel | translate) ||
                      'generic_subscription_' + subscription.type | translate
                  }}</span>

                  <div class="d-flex">
                    <!-- <span *ngIf="subscriptionWarning(subscription) === 'expired'" class="alert-expired">Expired</span>
                    <span
                      *ngIf="subscriptionWarning(subscription) === 'expired'"
                      class="sub-expired"
                      [inlineSVG]="'assets/images/icons/icon-info-anyColor.svg'"
                    ></span> -->
                    <!-- <span
                      *ngIf="subscriptionWarning(subscription) === 'expiring'"
                      class="sub-expiring"
                      [inlineSVG]="'assets/images/icons/icon-info-anyColor.svg'"
                    ></span> -->

                    <span
                      class="credit__checkbox align-self-center"
                      [ngClass]="{
                        'date-expired': false,
                        'date-expiring': false
                      }"
                      >{{ subscription.details.subscriptionExpiryTime | date: user.preferences.dateFormat }}</span
                    >
                  </div>
                </div>
                <div class="custom-display-subscription" *ngIf="isActiveSubscriptionTrial(subscription)">
                  <span class="credit__name">{{ subscription.details.note | translate }}</span>
                  <!-- <span class="credit__checkbox">{{ subscription.details.subscriptionExpiryTime | date: user.preferences.dateFormat }}</span> -->
                </div>
              </div>
            </li>
          </ul>

          <span *ngIf="singleSub.length === 0 && subBundled.length === 0" class="dropdown-menu__text d-block mb-2" translate
            >topmenu_subscription_none</span
          >

          <!--  old <ng-container *ngIf="!(user?.account?.postpaid)">
          <wsb-atlas-button *ngIf="!domain.shopUrl && allowProfileManageAndShopAndBilling && menuEntries['shop'] && !isSubaccount" class="mb-2" [label]="'topmenu_subscription_buy'" routerLink="/shop/index" [queryParams]="{type: 'subscription'}">{{ 'topmenu_subscription_buy' | translate }}</wsb-atlas-button>
        </ng-container> -->
          <ng-container *ngIf="!user?.account?.postpaid">
            <wsb-atlas-button
              *ngIf="allowProfileManageAndShopAndBilling && menuEntries['internal_shop'] && !isSubaccount"
              class="mb-2"
              [label]="'topmenu_subscription_buy'"
              routerLink="/shop/index"
              >{{ 'topmenu_subscription_buy' | translate }}</wsb-atlas-button
            >
          </ng-container>
        </div>
      </ng-template>

      <ng-template #creditsTab>
        <ng-container *ngIf="user?.account?.postpaid || (credit && credit.money !== null)">
          <p class="heading-md  mb-0  color-primary" [ngSwitch]="user?.account?.postpaid">
            <span *ngSwitchCase="false">
              {{ currency }} {{ creditFormattedDigits }}<small class="fs-13">{{ decimalSeparator }}{{ creditFormattedFractions }}</small>
            </span>
            <span *ngSwitchCase="true" translate>atlas_credits_postpaid_user_money</span>
          </p>
        </ng-container>
        <div class="row flex align-items-center" *ngIf="creditsList && creditsList.length && !user?.account?.postpaid">
          <p class="dropdown-menu__text  position-relative col-md-10 m-0">
            <span translate>topmenu_credits_usage</span>
          </p>
          <p class="dropdown-menu__text position-relative m-0 p-0 ps-2 col-md-2">
            <small translate>topmenu_show_credits</small>&nbsp;<small>({{ counterCurrentCredits }}/{{ maxSelectableCredits }})</small>
          </p>
        </div>

        <ul class="credits-list  list-unstyled  my-4" *ngIf="creditsList && creditsList.length && !user?.account?.postpaid">
          <li *ngFor="let credit of creditsList | filterCreditsType: false" class="credits-list__item credit">
            <span class="credit__name">
              <img [ngClass]="{ 'credit-destination-flag': !!credit.credits.nation }" src="{{ credit.icon }}" [alt]="credit.title" />
              <span *ngIf="!credit.credits.nation && !credit.title">{{
                'credit_type_' + credit.credits.type | lowercase | translate
              }}</span>
              <span *ngIf="!credit.credits.nation && credit.title">{{ credit.title }}</span>
              <span *ngIf="credit.credits.nation">{{ credit.credits.nation | uppercase }}</span>
            </span>
            <span class="credit__quantity">{{ formatIntNumber(credit.credits.quantity) }}</span>
            <wsb-ui-checkbox
              class="credit__checkbox  d-none  d-md-inline-flex"
              [checkboxId]="credit.credits.type"
              [(checked)]="credit.enabled"
              [disabled]="(!credit.enabled && disableExtraCredits) || creditsUpdateInProgress"
              (checkedChange)="updateCreditsPreferences()"
            >
            </wsb-ui-checkbox>
          </li>
        </ul>

        <a
          *ngIf="creditsList && hasNations && !user?.account?.postpaid"
          class="toggle-nations"
          wsbAppClickStopPropagation
          (click)="toggleNationsCredits()"
        >
          <wsb-ui-icon class="triangle-icon" [icon]="'faCaretRight'" [@rotateTriangle]="rotationState"></wsb-ui-icon>

          {{ 'topmenu_show_foreign_credits' | translate }}</a
        >
        <div class="credits-nations-container">
          <ul
            class="credits-list list-unstyled  my-4"
            [ngClass]="{ 'nations-credits': addCSSClass }"
            *ngIf="showNationCredits.value && creditsList && creditsList.length && !user?.account?.postpaid"
          >
            <li *ngFor="let credit of creditsList | filterCreditsType: true" class="credits-list__item credit">
              <span class="credit__name">
                <img [ngClass]="{ 'credit-destination-flag': !!credit.credits.nation }" src="{{ credit.icon }}" [alt]="credit.title" />
                <span *ngIf="!credit.credits.nation && !credit.title">{{
                  'credit_type_' + credit.credits.type | lowercase | translate
                }}</span>
                <span *ngIf="!credit.credits.nation && credit.title">{{ credit.title }}</span>
                <span *ngIf="credit.credits.nation">{{ credit.credits.nation | uppercase }}</span>
              </span>
              <span class="credit__quantity">{{ formatIntNumber(credit.credits.quantity) }}</span>
              <wsb-ui-checkbox
                [ngClass]="{ 'pe-2': addCSSClass }"
                class="credit__checkbox  d-none  d-md-inline-flex"
                [checkboxId]="credit.credits.type"
                [(checked)]="credit.enabled"
                [disabled]="(!credit.enabled && disableExtraCredits) || creditsUpdateInProgress"
                (checkedChange)="updateCreditsPreferences()"
              >
              </wsb-ui-checkbox>
            </li>
          </ul>
        </div>

        <ng-container *ngIf="!user?.account?.postpaid">
          <div class="d-flex" style="gap: 10px">
            <a target="_blank" *ngIf="menuEntries['external_shop']" [href]="domain.shopUrl + '?id=' + userIdKey"
              ><wsb-atlas-button class="mb-2" [label]="'topmenu_credits_buy'">{{ 'topmenu_credits_buy' | translate }}</wsb-atlas-button></a
            >
            <wsb-atlas-button
              *ngIf="allowProfileManageAndShopAndBilling && menuEntries['internal_shop']"
              [label]="'topmenu_credits_buy'"
              routerLink="/shop/index"
              [queryParams]="{ type: 'sms' }"
              >{{ 'topmenu_credits_buy' | translate }}</wsb-atlas-button
            >
            <wsb-atlas-button
              *ngIf="displayCreditsMovementsForSubAccounts()"
              class="mb-2"
              [label]="'purchase_history'"
              routerLink="/account/purchase-history"
              >{{ 'purchase_history' | translate }}</wsb-atlas-button
            >
          </div>
        </ng-container>
      </ng-template>

      <li [ngbNavItem]="1">
        <a wsbAppClickStopPropagation ngbNavLink class="pt-0">{{
          (changeTabOrder ? 'topmenu_subscriptions' : 'topmenu_credits') | translate
        }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="tabOrder[0]"> </ng-container>
        </ng-template>
      </li>
      <li [ngbNavItem]="2">
        <a wsbAppClickStopPropagation ngbNavLink class="pt-0">{{
          (changeTabOrder ? 'topmenu_credits' : 'topmenu_subscriptions') | translate
        }}</a>
        <ng-template ngbNavContent>
          <ng-container *ngTemplateOutlet="tabOrder[1]"> </ng-container>
        </ng-template>
      </li>
    </ul>
  </div>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
